import React from "react";
import {Typography} from "@material-ui/core";

// components
import RenderCheckBox from "../atoms/RenderCheckBox";

// resources
import { narrowDown } from '~/data/shop/itemSearchOption'
import {Field} from "react-final-form";
import {css} from "@emotion/react";
import colorPalette from "../../../styles/theme/colorPalette";

export const AllergenField = React.memo(() => {
  return (
      <>
        <Typography>七大アレルゲン</Typography>
        <Typography css={caution}><span>アレルゲンが気になる方はチェックを外してください。検索結果から除外されます。</span></Typography>
        <Field
            id="allergens"
            name="allergens"
            labels={narrowDown.allergen.map((allergen) => allergen.label)}
            vals={narrowDown.allergen.map((allergen) => allergen.code)}
            component={RenderCheckBox}
            css={checkboxStyle}
        />
      </>
  )
})
AllergenField.displayName = 'AllergenField'


const caution = css`
  line-height: 1;
  span {
    font-size: 12px;
    color: ${colorPalette.gray};
  }
`

const checkboxStyle = css`
  width: 11rem;
  span:first-of-type {
    padding: 0.5rem 0.5rem 0.5rem 1rem;
  }
  span:last-of-type {
    padding: 0.5rem 0;
    font-size: 1.4rem;
  }
`